export default "__VITE_ASSET__65d699c8__"